import { SET_TIMEOUT_VALUE } from "../../../../constants/app-constants";
import { withApollo } from "react-apollo";
import React from "react";
import DisplayErrors from "../../../Common/DisplayErrors";
import DatePicker from "react-datepicker";
import { format, isDate } from "date-fns";
import { updateAutoNumberingQuery } from "../../../../services/graphql/queries/auto-numbering";

class AutoNumberingModify extends React.Component {
  constructor() {
    super();

    this.state = {
      id: "",
      startDate: "",
      startDateMsg: "",
      endDate: "",
      endDateMsg: "",
      nextNumber: "",
      nextNumberMsg: "",
      returnAs: "",
      returnAsMsg: "",
      prefix: "",
      suffix: "",
      padding: "",
      paddingMsg: "",
      paddingLength: "",
      paddingLengthMsg: "",
      formStyle: "",
      errors: [],
      isSubmitDisable: false
    };

    this.submitForm = this.submitForm.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
  }

  componentDidMount() {
    const {
      Id,
      startDate,
      endDate,
      nextNumber,
      returnsAs,
      prefix,
      suffix,
      padding,
      nextNoLen
    } = this.props.selectedRecord;

    this.setState({
      id: Id,
      startDate: startDate,
      endDate: endDate,
      nextNumber: nextNumber,
      returnAs: returnsAs,
      prefix: prefix,
      suffix: suffix,
      padding: padding,
      paddingLength: nextNoLen
    });
  }

  // componentDidUpdate() {
  //   const {
  //     id,
  //   } = this.props.selectedRecord;

  //   console.log("cdu", this.props);

  //   if (id !== this.state.id) {
  //     this.setState({
  //       id,
  //     });
  //   }
  // }
  handleValidation() {
    console.log("handle validation");
    var isValid = true;
    var style = "is-invalid";
    if (this.state.startDate == "" || this.state.startDate == 0) {
      this.setState({
        startDateMsg: "Please select a Start date",
        formStyle: style
      });
      isValid = false;
    } else {
      this.setState({
        startDateMsg: ""
      });
    }

    if (this.state.endDate == "") {
      this.setState({
        endDateMsg: "Please select a End Date",
        formStyle: style
      });
      isValid = false;
    } else {
      this.setState({
        endDateMsg: ""
      });
    }

    if (this.state.nextNumber == "") {
      this.setState({
        nextNumberMsg: "*Error : Enter the next sequence number        ",
        formStyle: style
      });
      isValid = false;
    } else {
      this.setState({
        nextNumberMsg: ""
      });
    }

    if (this.state.returnAs == "") {
      this.setState({
        returnAsMsg: '*Error : Select the valid "Return as" option        ',
        formStyle: style
      });
      isValid = false;
    } else {
      if (this.state.returnAs == "S") {
        if (this.state.padding == "" || this.state.padding == 0) {
          this.setState({
            paddingMsg:
              '*Error : Select the valid "Return as" option & Padding value            ',
            formStyle: style
          });
          isValid = false;
        } else {
          this.setState({
            paddingMsg: ""
          });
        }

        if (this.state.paddingLength == "" || this.state.paddingLength == 0) {
          this.setState({
            paddingLengthMsg:
              '*Error : Select the valid "Return as" option & Padding length            ',
            formStyle: style
          });
          isValid = false;
        } else {
          this.setState({
            paddingLengthMsg: ""
          });
        }
      }

      this.setState({
        returnAsMsg: ""
      });
    }
    return isValid;
  }
  submitForm(e) {
    if (this.handleValidation()) {
      e.preventDefault();
      this.setState({ isSubmitDisable: true });
      this.props.client
        .mutate({
          mutation: updateAutoNumberingQuery,
          variables: {
            id: this.state.id,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            nextNumber: parseInt(this.state.nextNumber),
            returnAs: this.state.returnAs,
            prefix: this.state.prefix,
            suffix: this.state.suffix,
            padding: this.state.padding,
            nextNoLen: this.state.paddingLength
              ? parseInt(this.state.paddingLength)
              : 0
          },
          fetchPolicy: "no-cache"
        })
        .then(result => {
          this.setState({ isSubmitDisable: false });
          this.props.listMode(true);
          this.props.switchToListMode();
        })
        .catch(error => {
          console.log("~~~error: ", error);
          this.setState({ isSubmitDisable: false });
          error.graphQLErrors.map(({ message }, i) => {
            this.setState(prevState => {
              return { errors: [message] };
            });
          });
          setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    }
  }

  render() {
    const { errors, isSubmitDisable, startDate, endDate } = this.state;
    debugger;
    return (
      <div>
        <div className="">
          <div className="row m-b-25 align-items-center">
            <div className="col-md-10">
              <h1 className="heading m-b-0">Modify Auto Numbering</h1>
              <div
                className="row"
                style={{
                  display: errors.length === 0 ? "none" : "block"
                }}
              >
                <div className="col-md-6">
                  <div className="alert alert-success" role="alert">
                    <div className="row">
                      <img src="/static/images/svg/Serverclose.svg" />
                      <span className="danger-link">
                        <DisplayErrors errors={errors} />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-2 text-right">
              <a
                href="#"
                className="link-click m-l-45"
                onClick={() => this.props.listMode(true)}
              >
                <img src="/static/images/svg/Close.svg" /> Close
              </a>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="row" style={{ display: "none" }}>
              <div className="col-md-8">
                {/*Alert Section start */}
                <div className="alert alert-success m-b-35" role="alert">
                  Success
                </div>
                {/*Alert Section End */}
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>START DATE</label>
                  <span style={{ color: "#ff0000", fontSize: "16px" }}>*</span>
                  <DatePicker
                    className={
                      "form-control date " +
                      (this.state.startDateMsg != ""
                        ? this.state.formStyle
                        : "")
                    }
                    dateFormat="dd-MM-yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    placeholderText="DD-MM-YYYY"
                    selected={startDate === "" ? null : startDate}
                    onChange={dt => {
                      if (isDate(dt)) {
                        this.setState({
                          startDate: format(new Date(dt), "YYYY-MM-DD")
                        });
                      } else {
                        this.setState({ startDate: "" });
                      }
                    }}
                  />
                  <br />
                  <div class="invalid-feedback" style={{ display: "block" }}>
                    {this.state.startDateMsg}
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>END DATE</label>
                  <span style={{ color: "#ff0000", fontSize: "16px" }}>*</span>
                  <DatePicker
                    className={
                      "form-control date " +
                      (this.state.endDateMsg != "" ? this.state.formStyle : "")
                    }
                    dateFormat="dd-MM-yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    placeholderText="DD-MM-YYYY"
                    selected={endDate === "" ? null : endDate}
                    minDate={new Date(startDate)}
                    onChange={dt => {
                      if (isDate(dt)) {
                        this.setState({
                          endDate: format(new Date(dt), "YYYY-MM-DD")
                        });
                      } else {
                        this.setState({ endDate: "" });
                      }
                    }}
                  />
                  <br />
                  <div class="invalid-feedback" style={{ display: "block" }}>
                    {this.state.endDateMsg}
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>NEXT NUMBER</label>
                  <span style={{ color: "#ff0000", fontSize: "16px" }}>*</span>
                  <input
                    type="number"
                    className={
                      "form-control " +
                      (this.state.nextNumberMsg != ""
                        ? this.state.formStyle
                        : "")
                    }
                    placeholder="#no"
                    value={this.state.nextNumber}
                    onChange={e => {
                      this.setState({ nextNumber: e.target.value });
                    }}
                  />
                  <div class="invalid-feedback" style={{ display: "block" }}>
                    {this.state.nextNumberMsg}
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>RETURN AS</label>
                  <span style={{ color: "#ff0000", fontSize: "16px" }}>*</span>
                  <select
                    className={
                      "form-control select-style-1 " +
                      (this.state.returnAsMsg != "" ? this.state.formStyle : "")
                    }
                    value={this.state.returnAs}
                    onChange={e => {
                      this.setState({ returnAs: e.target.value });
                      if (e.target.value === "N" || e.target.value === "") {
                        this.setState({
                          prefix: "",
                          suffix: "",
                          padding: "",
                          paddingMsg: "",
                          paddingLength: "",
                          paddingLengthMsg: ""
                        });
                      }
                    }}
                  >
                    <option value={""}>Select</option>
                    <option value={"N"}>Number</option>
                    <option value={"S"}>String</option>
                  </select>
                  <div class="invalid-feedback" style={{ display: "block" }}>
                    {this.state.returnAsMsg}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>PREFIX</label>
                  <input
                    type="text"
                    className={"form-control "}
                    placeholder="Enter Prefix"
                    maxLength="5"
                    value={this.state.prefix}
                    disabled={this.state.returnAs == "N" ? true : false}
                    onChange={e => {
                      this.setState({ prefix: e.target.value.toUpperCase() });
                    }}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>SUFFIX</label>
                  <input
                    type="text"
                    className={"form-control "}
                    placeholder="Enter Suffix"
                    maxLength="5"
                    value={this.state.suffix}
                    disabled={this.state.returnAs == "N" ? true : false}
                    onChange={e => {
                      this.setState({ suffix: e.target.value.toUpperCase() });
                    }}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>PADDING</label>
                  {this.state.returnAs == "S" ? (
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>
                  ) : null}
                  <input
                    type="text"
                    style={{ width: "25%" }}
                    className={
                      "form-control " +
                      (this.state.paddingMsg != "" ? this.state.formStyle : "")
                    }
                    placeholder="X"
                    maxLength="1"
                    value={this.state.padding}
                    disabled={this.state.returnAs == "N" ? true : false}
                    onChange={e => {
                      this.setState({ padding: e.target.value });
                    }}
                  />
                  <div class="invalid-feedback" style={{ display: "block" }}>
                    {this.state.paddingMsg}
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>PADDING LENGTH</label>
                  {this.state.returnAs == "S" ? (
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>
                  ) : null}
                  <input
                    type="number"
                    style={{ width: "25%" }}
                    className={
                      "form-control " +
                      (this.state.paddingLengthMsg != ""
                        ? this.state.formStyle
                        : "")
                    }
                    placeholder="##"
                    maxLength="2"
                    min="3"
                    max="10"
                    value={this.state.paddingLength}
                    disabled={this.state.returnAs == "N" ? true : false}
                    onChange={e => {
                      this.setState({ paddingLength: e.target.value });
                    }}
                  />
                  <div class="invalid-feedback" style={{ display: "block" }}>
                    {this.state.paddingLengthMsg}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-10">
              <div className="row">
                <div className="col-md-12 ">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={e => this.submitForm(e)}
                    disabled={isSubmitDisable}
                  >
                    Modify
                  </button>
                  <button
                    type="button"
                    className="btn btn-light m-l-50"
                    onClick={() => {
                      this.props.listMode(true);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            {/* <div className="row">
              <div className="col-md-4 col-lg-3">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={e => this.submitForm(e)}
                  disabled={isSubmitDisable} 
                >
                  Modify
                </button>
              </div>

              <div className="col-md-4 col-lg-3">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    this.props.listMode(true);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default withApollo(AutoNumberingModify);
